//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'
import Vue from 'vue'

export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      application: {}
    }
  },
  created () {
  },
  mounted () {
    this.getApplication()
  },
  computed: {
  },
  methods: {
    getApplication: function () {
      let $this = this
      Vue.http.get(this.serviceUrl('api/application')).then((resp) => {
        $this.application = resp.data.application;
      })
    },
    saveApp: function () {
      let self = this
      var params = self.application;
      Vue.http({
        method: 'PATCH',
        url: self.serviceUrl('api/application'),
        data: params
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          self.alert('保存成功', 1);
        } else {
          self.alert(resp.data.errmsg, 2);
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageApplication.vue